<template>
  <div>
    <p>delivered</p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
